import React, { useState, useEffect, useMemo } from 'react';
import {EuiAvatar, EuiFieldText, EuiFilterButton, EuiFilterGroup, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiLink, EuiPanel, EuiTitle} from '@elastic/eui';
import ListaDireccionesNegocioContainer from './ListadoDns';
import ListaAreasContainer from './ListadoAreas';
import './styles.css';

interface Props {
  users: any;
  handleGetPermissionsUser(user:any,fnCallBack:any):any;
  handleCreatePermissionsUser(user:any):any;
  launchNotification(data:any,dissmis:boolean):any;
}

const _tipos = [{label:'Todos',value:'t'}, {label:'Con Permisos',value:'cp'}, {label:'Sin Permisos',value:'sp'}]

export const UsuariosPermisosScreen = (props: Props) => {

  let { users, handleGetPermissionsUser, handleCreatePermissionsUser, launchNotification } = props;
  let [selected, setSelected] = useState<any>(undefined);
  let [dn, setDn] = useState<any>(undefined);
  let [searchUser, setSearchUser] = useState<any>({user:'',permiso:_tipos[0].value});

  useEffect(()=>{if(selected!==undefined)onChangeUser(selected)},[users])

  const onChangeUser = (userSelected:any) =>{
    handleGetPermissionsUser(userSelected,setSelected)
  }

  const onChangeDn = (newDn:any)=>{ setDn({...newDn})}

  const labelPermisosUser = (user:any) =>{
    return user.tienePermisos ? <EuiFlexItem grow={false}><EuiAvatar name="Permisos" title="Tiene Permisos" color='#83d6b6' size='s'/></EuiFlexItem> : null;
  }

  const getSearch = useMemo(()=>{
    return users && users.filter((f:any)=> { 
      return (searchUser.permiso==='sp' ? !f.tienePermisos : (searchUser.permiso==='cp' ? f.tienePermisos : f))
    }).filter((f:any)=> { 
      if(new RegExp(`${searchUser.user}.*`, "i").test(f["login"]) || new RegExp(`${searchUser.user}.*`, "i").test(f["nombre"])){return f}
    })
  },[users,searchUser])

  const getItemsUsuarios = useMemo(() =>{
    const filterArray:any = getSearch;
    return users && filterArray.map((d:any)=>{
        return (<EuiFlexItem grow={false}>
                  <EuiLink
                  className={`btn-list-user-permission ${selected && d.dni===selected.dni?'active':''}`}
                  onClick={() => {onChangeUser(d)}}
                  >
                  <EuiFlexGroup justifyContent='spaceAround' alignItems='center' gutterSize='s'>
                      <EuiFlexItem title={d.login}>{`${d.nombre}`}</EuiFlexItem>
                      {labelPermisosUser(d)}
                  </EuiFlexGroup>
                  </EuiLink>
        </EuiFlexItem>)
    })
},[users,searchUser,selected])

  const onSave = (dataPermisos:any) => {
    const permisos = dataPermisos===null ? {} : {idDN:dn.idDN,areas:dataPermisos.areas}
    const dataUser = {user:selected,idDNSel:dn.idDN,permisos:permisos}
    handleCreatePermissionsUser(dataUser)
  }

  const titleUser = useMemo(()=>{
    
    return selected ? (<EuiFlexGroup gutterSize='none' alignItems='center' style={{height:'2em'}}>
      <EuiFlexItem grow={false} className='titleIconPermission titleUserIconPermission'>
        <EuiIcon type='user' size='m'/>
      </EuiFlexItem>
      <EuiFlexItem grow={false} className='titlePermission titleUserPermission'>
        <EuiTitle size='xs'>
          <h5>{`${selected.nombre}`}</h5>
        </EuiTitle>
      </EuiFlexItem>
    </EuiFlexGroup>) : null

  },[selected])

  const titleLogin = useMemo(()=>{

    return selected ? (<EuiFlexGroup gutterSize='none' alignItems='center' style={{height:'2em'}}>
      <EuiFlexItem grow={false} className='titleIconPermission titleUserIconPermission'>
        <EuiIcon type='user' size='m'/>
      </EuiFlexItem>
      <EuiFlexItem grow={false} className='titlePermission titleUserPermission'>
        <EuiTitle size='xs'>
          <h5>{`${selected.login}`}</h5>
        </EuiTitle>
      </EuiFlexItem>
    </EuiFlexGroup>) : null

  },[selected])

  const titlePerfil = useMemo(()=>{

    return selected ? (<EuiFlexGroup gutterSize='none' alignItems='center' style={{height:'2em'}}>
      <EuiFlexItem grow={false} className='titleIconPermission titlePerfilIconPermission'>
        <EuiIcon type='annotation' size='m'/>
      </EuiFlexItem>
      <EuiFlexItem grow={false} className='titlePermission titlePerfilPermission'>
        <EuiTitle size='xs'>
          <h5>{`${selected.nombrePerfil}`}</h5>
        </EuiTitle>
      </EuiFlexItem>
    </EuiFlexGroup>) : null

  },[selected])

  const titleDn = useMemo(()=>{
    return dn ? (
      <EuiFlexGroup gutterSize='none' alignItems='center' style={{height:'2em'}}>
        <EuiFlexItem grow={false} className='titleIconPermission titleDnIconPermission'>
          <EuiIcon type='home' size='m'/>
        </EuiFlexItem>
        <EuiFlexItem grow={false} className='titlePermission titleDnPermission'>
          <EuiTitle size='xs'>
            <h5>{`${dn.idDN} - ${dn.direccionNegocio}`}</h5>
          </EuiTitle>
        </EuiFlexItem>
      </EuiFlexGroup>
    ) : null
  },[dn])

  return(
    <EuiFlexGroup direction='column' style={{height:'100%'}} gutterSize='none'>
      <EuiFlexItem style={{height:'100%'}}>
        <EuiFlexGroup style={{height:'100%'}} gutterSize='none'>
          <EuiFlexItem grow={3} style={{overflow:'hidden'}}>
            <EuiPanel style={{overflow:'hidden',borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}}>
              <EuiFlexGroup direction='column' style={{height:'100%'}}>
                <EuiFlexItem grow={false}>
                  <EuiFieldText placeholder='Buscar usuario o login...' value={searchUser.user} onChange={(e)=>setSearchUser({...searchUser,...{user:e.target.value}})}></EuiFieldText>
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <EuiFilterGroup fullWidth>
                    <EuiFilterButton
                      hasActiveFilters={searchUser.permiso===_tipos[0].value}
                      onClick={()=>setSearchUser({...searchUser,...{permiso:_tipos[0].value}})}>
                      {_tipos[0].label}
                    </EuiFilterButton>
                    <EuiFilterButton
                      hasActiveFilters={searchUser.permiso===_tipos[1].value}
                      onClick={()=>setSearchUser({...searchUser,...{permiso:_tipos[1].value}})}>
                        {_tipos[1].label}
                    </EuiFilterButton>
                    <EuiFilterButton
                      hasActiveFilters={searchUser.permiso===_tipos[2].value}
                      onClick={()=>setSearchUser({...searchUser,...{permiso:_tipos[2].value}})}>
                        {_tipos[2].label}
                    </EuiFilterButton>
                  </EuiFilterGroup>
                </EuiFlexItem>
                <EuiFlexItem style={{overflow:'hidden'}}>
                  <EuiFlexGroup direction='column' style={{height:'100%',width:'100%',overflow:'auto'}} gutterSize='m'>
                    {getItemsUsuarios}
                  </EuiFlexGroup>
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiPanel>
          </EuiFlexItem>

          <EuiFlexItem grow={10}>
            <EuiPanel style={{height:'100%',borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px'}}>
              {selected ?
              <>
              <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter" wrap style={{height:'10%'}}>
                <EuiFlexItem grow={false}>
                  {titleUser}
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  {titleLogin}
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  {titlePerfil}
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  {titleDn}
                </EuiFlexItem>
              </EuiFlexGroup>
              <EuiFlexGroup gutterSize='none' style={{height:'90%'}}>
                <EuiFlexItem grow={false} style={{height:'100%'}}>
                  <EuiPanel style={{height:'100%',borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}}>
                    <ListaDireccionesNegocioContainer onClickDn={onChangeDn} dnSel={dn?dn.idDN:undefined} permissions={selected.permisos}/>
                  </EuiPanel>
                </EuiFlexItem>
                <EuiFlexItem>
                  <EuiPanel style={{height:'100%',borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px'}}>
                    <ListaAreasContainer dn={dn?dn.idDN:undefined} onSavePermisos={onSave} permissions={selected.permisos} dnUser={selected.idDN}/>
                  </EuiPanel>
                </EuiFlexItem>
              </EuiFlexGroup>
              </>
              :null}
            </EuiPanel>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiFlexGroup>
  )
};

export default UsuariosPermisosScreen;
